var chunkMapping = {
	"33": [
		70033
	],
	"65": [
		70065
	],
	"474": [
		60474
	],
	"1254": [
		1254
	],
	"1469": [
		71469
	],
	"1566": [
		51566
	],
	"1984": [
		91984
	],
	"2158": [
		52158
	],
	"2403": [
		72403
	],
	"2434": [
		12434
	],
	"2468": [
		72468
	],
	"3481": [
		43481
	],
	"3576": [
		83576
	],
	"4067": [
		44067
	],
	"4420": [
		67077
	],
	"4715": [
		74715
	],
	"4995": [
		64995
	],
	"5261": [
		5261
	],
	"6490": [
		16490
	],
	"7066": [
		57066
	],
	"7967": [
		47967
	],
	"7973": [
		7973
	],
	"8333": [
		81602
	],
	"8662": [
		88662
	],
	"8704": [
		78704
	],
	"9037": [
		89037
	],
	"9446": [
		9446
	],
	"9685": [
		89685
	],
	"9770": [
		69770
	]
};
var idToExternalAndNameMapping = {
	"1254": [
		"default",
		"./OrderRoutesContainer",
		38015
	],
	"5261": [
		"default",
		"./settings/DispatchWaveConfiguration",
		38015
	],
	"7973": [
		"default",
		"./routes/NetOptEntityRouteContainer",
		89098
	],
	"9446": [
		"default",
		"./DispatcherContainer",
		96007
	],
	"12434": [
		"default",
		"./alerts/AlertsPreference",
		1799
	],
	"16490": [
		"default",
		"./LiveViewRoutesContainer",
		72587
	],
	"43481": [
		"default",
		"./settings/BannerConfiguration",
		72587
	],
	"44067": [
		"default",
		"./settings/SMSConfiguration",
		72587
	],
	"47967": [
		"default",
		"./routes/DigitalTwinRouteContainer",
		89098
	],
	"51566": [
		"default",
		"./settings/RuleSetContainer",
		96233
	],
	"52158": [
		"default",
		"./QuotationsContainer",
		38015
	],
	"57066": [
		"default",
		"./auditTrail/AuditTrailContainer",
		1799
	],
	"60474": [
		"default",
		"./analytics/MetricsRoutes",
		1799
	],
	"64995": [
		"default",
		"./reports/ReportsContainer",
		1799
	],
	"67077": [
		"default",
		"./premiumFeatures/PremiumFeaturesContainer",
		1799
	],
	"69770": [
		"default",
		"./ContractsContainer",
		96007
	],
	"70033": [
		"default",
		"./settings/SlotAttributeConfiguration",
		72587
	],
	"70065": [
		"default",
		"./alerts/AlertsToastContainer",
		1799
	],
	"71469": [
		"default",
		"./RosterContainer",
		96007
	],
	"72403": [
		"default",
		"./routes/OptimisationRouteContainer",
		89098
	],
	"72468": [
		"default",
		"./BagModelMasterContainer",
		38015
	],
	"74715": [
		"default",
		"./settings/ChecklistConfiguration",
		72587
	],
	"78704": [
		"default",
		"./SingleRiderV1RoutesContainer",
		72587
	],
	"81602": [
		"default",
		"./analytics/InsightsRoutes",
		1799
	],
	"83576": [
		"default",
		"./alerts/AlertsContainer",
		1799
	],
	"88662": [
		"default",
		"./alerts/NotificationBell",
		1799
	],
	"89037": [
		"default",
		"./roleMaster/RoleMaster",
		1799
	],
	"89685": [
		"default",
		"./OrchestrationContainer",
		96233
	],
	"91984": [
		"default",
		"./TourManagementContainer",
		38015
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}